var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"big"},[_vm._v("\n    北京海葵科技有限公司版权所有\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2349d75e","hasScoped":true,"optionsId":"0","buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 